import { render } from "./CurrenciesSettsPage.vue?vue&type=template&id=1b91c48e&ts=true"
import script from "./CurrenciesSettsPage.vue?vue&type=script&lang=ts"
export * from "./CurrenciesSettsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__